import type { UnitReferralDTO } from "~/services/swagger/Api";

// Build the absolute URL of the backend referral-redirect endpoint so a partner
// CTA click is tracked server-side: the backend logs a ReferralClick and 302s to
// the resolved partner target (object referral link → provider default → soft
// fallback). Returns undefined when the unit has no resolvable referral target,
// so callers can fall back to the raw referral/external/provider url.
export const buildReferralRedirectUrl = (
  referral: UnitReferralDTO | undefined
): string | undefined => {
  if (!referral?.hasLink || !referral.path) return undefined;

  const config = useRuntimeConfig();
  const base = (config.public.baseURL as string) || "";

  return `${base}/api/${referral.path}`;
};
